export default __webpack_public_path__ + "static/media/android-guide1.9dcf3775.png";